import { clone, ui as _ui, state as _state, res, prefs, live } from './stores.js';
import { tick } from 'svelte/internal';
import { get } from 'svelte/store';
import { getIconURL, getNewIcon } from './card_images.js'
import { autoActionButton, cardOwner, doActionPause, getHints } from './parse.js';
import { look, lookAtCards, closeLook, cardMessage, closeAllLooks, allActions } from './card_actions.js';
import { doAction, getCard, getDeckForCard, getPlayerIndex, prng } from './game.js';
import { until } from './turns.js';
import { dbUpdateGame, updateGame } from './sb.js';
import { changePlayer } from './net.js';
import { getContinuationResForSync, noteContinuationChoice, setContinuationWaiting } from './continuation.js';

export function select(c, facedown){
    _ui.update(ui => {
        //ui.previewDashboard = null;
        ui.dashboardSelected = false;
        /*if(isTouchDevice()){
            ui.hoveringCard = c;
        }*/
        if(!ui.multiSelection){
            ui.selection = c;
            ui.facedown = facedown;
        }else{
            if(facedown && (!ui.waiting[0] || !ui.waiting[0].number > 1)) return ui; // Can't select facedown cards in a multiple list
            ui.facedown = facedown;
            ui.multiSelection = [c, ...ui.multiSelection];
            if(ui.waiting[0] && ui.waiting[0].number < ui.multiSelection.length) ui.multiSelection = ui.multiSelection.slice(0, ui.multiSelection.length - 1); //Lose last card
            ui.selection = c;
        }
        return ui;
    })
    live.update(live => {
        if(isTouchDevice()){
            live.hoveringCard = c;
        }
        live.previewDashboard = null;
        return live;
    })
    //console.log(get(_ui));
}

export function deselect(c){
    live.update(live => {
        live.previewDashboard = null;
        if(isTouchDevice()){
            live.hoveringCard = null;
        }
        return live;
    })
    _ui.update(ui => {
        ui.dashboardSelected = false;
        //ui.previewDashboard = null;
        /*if(isTouchDevice()){
            ui.hoveringCard = null;
        }*/
        if(!ui.multiSelection){
            ui.selection = null;
            //ui.facedown = false;
        }else{
            ui.multiSelection = ui.multiSelection.filter(s => s != c);
            if(ui.selection == c){
                if(ui.multiSelection.length > 0){
                    ui.selection = ui.multiSelection[0];
                }else{
                    ui.selection = null;
                }
            }
        }
        return ui;
    })
}

export function clearSelection(){
    _ui.update(ui => {
        ui.selection = null;
        ui.facedown = false;
        ui.dashboardSelected = false;
        
        return ui;
    })
    live.update(live => {
        live.previewDashboard = false;
        live.dashboardArea = false;
        return live;
    })
}

export function toggleSelect(c, facedown){
    console.log(c, get(res).parsedCardText[c.id], get(res).atCards[c.id]);
    let ui = get(_ui);
    if(isSelected(ui, c)){
        deselect(c, facedown)
    }else{
        select(c, facedown);
    }
}

export function isSelected(ui, c){
    if(!c) return false;
    if(ui.selection == c) return true;
    if(ui.multiSelection && ui.multiSelection.includes(c)) return true;
    return false;
}

export function convert(text, fullText = false, fallback = true){
    if(!text) return '';

    let icons = [...get(res).icons, ...get(res).ships, 'away-teams', 'away', 'drone', 'murf', 'drone', 'mil-guard', 'res-guard', 'inf-guard', 'action', 'different-species', 'same-species', 'different species', 'any species', 'same species', 'spec-res', 'spec-mil', 'spec-inf', 'away-team', 'away team', 'res-focus', 'mil-focus', 'inf-focus', 'inf-restriction', 'mil-restriction','res-restriction', 'collective', 'treachery', 'whim'];
    //console.log(icons)
    if(!icons) return text;
    if(!text) return '';
    let inverted = false;
    if(text.startsWith('#i#')){
     inverted = true;
     text = text.slice(3);
    }
    text = text.replaceAll(`/$`, '</span>');
    text = text.replaceAll(`/@`, '</span>');
    text = text.replaceAll(`$`, `<span style="font-weight: bold; color: green;">`)
    text = text.replaceAll(`@`, `<span style="font-weight: bold; color: red;">`)
    text = text.replaceAll(/\*([^*]+)\*/g, '<strong>$1</strong>');
        text = text.replaceAll(/Start:/g, '<strong>Start:</strong>');
        text = text.replaceAll(/Free Action:/g, '<strong>Free Action:</strong>');
        text = text.replaceAll(/Action:/g, '<strong>Action:</strong>');
        text = text.replaceAll(/Play:/g, '<strong>Play:</strong>');
        text = text.replaceAll(/Play \[\[action\]\]:/g, '<strong>Play [[action]]:</strong>');
        text = text.replaceAll(/Passive:/g, '<strong>Passive:</strong>');
        text = text.replaceAll(/Goal:/g, '<strong>Goal:</strong>');
        text = text.replaceAll(/Reward:/g, '<strong>Reward:</strong>');
        text = text.replaceAll(/Endgame:/g, '<strong>Endgame:</strong>');
        text = text.replaceAll(/Activation:/g, '<strong>Activation:</strong>');
        text = text.replaceAll(/Support:/g, '<strong>Support:</strong>');
        text = text.replaceAll(/Resupply:/g, '<strong>Resupply:</strong>');
        text = text.replaceAll(/Clean-up:/g, '<strong>Clean-up:</strong>');
        text = text.replaceAll(/Reaction:/g, '<strong>Reaction:</strong>');
        text = text.replaceAll(/Control:/g, '<strong>Control:</strong>');
        text = text.replaceAll(/Special:/g, '<strong>Special:</strong>');
        text = text.replaceAll(/Surprise (Bot only):/gi, '<strong>Surprise (Bot only):</strong>');
        text = text.replaceAll(/\{([^}]+)\}/g, '<strong><em>$1</em></strong>');
        text = text.replaceAll(/\[\[drone:([0-9]+?)\]\]/g, (match, amount, offset, string) => {
            amount = parseInt(amount);
            let ret = ``;
            for(let i of Array(amount)){
                ret = `${ret}<img src="${getIconURL('drone')}" style="width: 1em; height: 1em; vertical-align: middle;" />`;
            }
            return ret;
        });
        text = text.replaceAll(/\[\[([0-9?]+?)vp\]\]/g, (match, amount, offset, string) => {
            if(amount == '?') return `<img src="vp-positive.png" style="width: 1em; height: 1em; vertical-align: middle;" /><span style="margin-left: -1em; font-weight: bold; text-shadow: -1px -1px 0 black, 1px -1px 0 black, -1px 1px 0 black, 1px 1px 0 black; color: white;">VP</span>`;
            amount = parseInt(amount);
            if(amount > 0) return `<img src="vp-positive.png" style="width: 1em; height: 1em; vertical-align: middle;" /><span style="margin-left: -1em; font-weight: bold; text-shadow: -1px -1px 0 black, 1px -1px 0 black, -1px 1px 0 black, 1px 1px 0 black; color: white;">${amount}</span>`;
            return `<img src="vp-negative.png style="width: 1em; height: 1em; vertical-align: middle;" /><span style="margin-left: -1em; font-weight: bold; text-shadow: -1px -1px 0 black, 1px -1px 0 black, -1px 1px 0 black, 1px 1px 0 black; color: white;">${amount}</span>`;
        });
        text = text.replaceAll(/\[\[cpt-([a-z]+)\]\]/g, (match, trait) => {
            let style = `width: 1em; height: 1em; vertical-align: middle;${inverted ? ' filter: invert(1);' : ''}`;
            let out = `<img src="${getNewIcon('cap-restriction')}" style="${style}" />`;
            if(trait == 'restriction') return out; // [[cpt-restriction]] is the bare icon
            let url = getIconURL(trait);
            if(!url) return match;
            return `${out}<img src="${url}" style="${style}" />`;
        });
        text = text.replaceAll(/\[\[([^\]]+?)(-small)?\]\]/g,  (match, p1, p2, offset, string) => {
            if(p1.startsWith('_generic_ship')) p1 = 'uss_rio_grande';
            if(p1 == 'different species') p1 = 'different-species';
            if(p1 == 'any species') p1 ='any-species';
            if(!icons.includes(p1.toLowerCase())) return match;
            let size = 1;
            if(p2 == 'small') size = 0.8;
            //console.log(p1)
            // TODO handle p2 i.e. small icons
            if(getIconURL(p1.toLowerCase())){
                let bgColor = 'white';
                let fgColor = 'black';
                if(p1.toLowerCase().includes('away team') || p1.toLowerCase().includes('away-team')) bgColor = 'aqua';
                if(get(res).species.includes(p1)){
                    bgColor = 'darkorange';
                    fgColor = 'white';
                }
                return `<img src="${getIconURL(p1.toLowerCase())}" style="width: ${size}em; height: ${size}em; vertical-align: middle; ${get(res).ships.includes(p1) ? 'background-color: '+bgColor+';' : ''} ${inverted ? 'filter: invert(1);' : ''}" />${fullText ? '<div style="display:inline; background-color: '+bgColor+'; color: '+fgColor+'; font-size: 0.8em; border: 1px solid black;' + (inverted ? 'filter: invert(1);' : '') +'">'+p1[0].toUpperCase()+p1.slice(1)+'</div>' : ''}`;
            }else{
                //console.warn('Could not find image for '+p1.toLowerCase())
                if(fallback) return `[[${p1.toLowerCase()}]]`; // So that missing ones are covered!
                return p1; // Or just the text
            }
            //return `<img src="${p1.toLowerCase()}.png" style="width: ${size}em; height: ${size}em;; vertical-align: middle;" />`;
        });
        text = text.replaceAll(/\#newline/g, '<br />');
        text = text.replaceAll(/([A-Za-z \[\]]+)\s+\[\[(res|mil|inf)(\d+)\]\]:/gi, (match, p1, p2, p3, offset, string) => {
            return `<strong style="display: inline-flex; align-items: center;">${p1}&nbsp;<span style="margin-left: 0.3em; font-weight: bold; text-shadow: -1px -1px 0 black, 1px -1px 0 black, -1px 1px 0 black, 1px 1px 0 black; color: white; ${inverted ? 'filter: invert(1);' : ''}">(requires ${p3}</span><img style="width: 1.5em; height: 1.5em; vertical-align: middle;" src="${getIconURL(p2+'-restriction')}" />):</strong>`
        });
        
        
        text = text.replaceAll(/Attack /g, '<strong>Attack </strong>');
        
        
        return text;
}

export function changeView(p){
    //let ui = _ui;
    if(get(_state).practice && p != 0) return;
    if(typeof p != 'number') p = getPlayerIndex(p);
    live.update(live => {
        live.hoveringCard = null;
        return live;
    })
    _ui.update(u => {
        //u.hoveringCard = null;
        u.dashboardSelected = false;
        u.selection = null;
        if(u.viewing != p){
            //console.log(p, get(_state).players[p]);
            if(p == -1) return u;
            announce(get(_state).players[p].captain);
        }
        u.viewing = p;
        //console.log(u.viewing, u.seat);
        return u;
    })
}

export function changeSeat(p){
    if(get(_state).practice && p != 0) return;
    _ui.update(u => {
        u.seat = p;
        u.animate = false;
        return u;
    })
    _state.update(s => {
        return s;
    })
    changeView(p);
}

export function reaction(message, options = {}){
    // Need to check seating and devices
    // and need a message type focussed on this?
    // could have a $ui.reaction array / single element?
    // or just $state.activePlayer? but will still need a way to trigger pause/choose 
    // on the other player's device.
    // if on the same device it's easy – just trigger pause/choose directly
    // and then changeView / seat to them
    // (changeSeat could have a confirm dialogue as an option to prevent
    // inadvertent seeing of cards)
}

export function info(message, options){
    if(get(res).BvB) return true;
    return pause(message, {skippable: true, ...options, cancellable: false});
}

export async function skipToEndOfTurn(){
    while(get(_ui).waiting.length > 0){
        let w = get(_ui).waiting;
        if(w[0] && (w[0].skippable || w[0].optional || w[0].turnMarker)){
            await advance();
        }else{
            throw 'cancelled'; // To get out of current choice/etc. loop
        }
    }
    //console.log('skipped to end of turn')
}

export async function skipIfCan(){
    let w = get(_ui).waiting;
    if(w[0] && (w[0].skippable || w[0].optional)){
        await advance();
        return true;
    }
    return false;
}

// For manual actions (card and mission buttons, shortcuts, auto-action buttons). They skip
// whatever optional prompt is showing before they run, and skipping one can finish the current
// turn step: the turn loop then carried on into the next step or phase while the action was
// still to come, so it resolved in the wrong phase – logged under the wrong heading, and
// step-limited triggers ("in your Control Step") missed. The turn loop holds at the next step
// boundary until every action wrapped here has finished (see takeTurns).
export async function withTurnHeld(fn){
    holdTurn();
    try{
        return await fn();
    }finally{
        releaseTurn();
    }
}

function holdTurn(){
    _ui.update(ui => {
        ui.manualActions = (ui.manualActions || 0) + 1;
        return ui;
    })
}

function releaseTurn(){
    _ui.update(ui => {
        ui.manualActions = Math.max(0, (ui.manualActions || 1) - 1);
        return ui;
    })
}

// The skips at the start of a manual action. They are logged as choices like any other, tagged
// (ms) so that catch-up can hold the turn across them too: a replayed skip holds it until the
// action it made way for has replayed, or the game would resume that action a step late.
export async function skipForManualAction(){
    _ui.update(ui => {
        ui.manualSkip = true;
        return ui;
    })
    try{
        while(await skipIfCan());
    }finally{
        _ui.update(ui => {
            ui.manualSkip = false;
            return ui;
        })
    }
}

function holdForReplayedSkip(choice){
    if(!choice || !choice.ms || get(_ui).replayHold) return;
    holdTurn();
    _ui.update(ui => {
        ui.replayHold = true;
        return ui;
    })
}

export function releaseReplayHold(){
    if(!get(_ui).replayHold) return;
    _ui.update(ui => {
        ui.replayHold = false;
        return ui;
    })
    releaseTurn();
}

// Called by the turn loop at each step boundary
export async function untilManualActionsDone(){
    while(get(_ui).manualActions){
        if(get(_ui).replayHold){
            // Nothing else drives catch-up while the turn is held, so replay the held action here
            let before = get(_state).choices.thisTurn.length;
            if(choicesToLoad() && !choicesToLoad(true)) await catchupOneStep();
            // The skip made way for nothing that was logged, or replay can't take it further
            if(get(_ui).replayHold && get(_state).choices.thisTurn.length == before) releaseReplayHold();
            continue;
        }
        await until(_ => !get(_ui).manualActions || get(_ui).replayHold, false, 50);
    }
}

function publishContinuationState(rightNow = true){
    if(!get(_state).gameShared || !get(_state).dbID) return;
    try{
        dbUpdateGame(
            get(_state),
            get(_state).choices.thisTurn,
            get(_ui),
            ['state_compressed', 'changelist'],
            {res: getContinuationResForSync()},
            rightNow
        );
    }catch(e){
        console.log('Unable to publish continuation state', e);
    }
}

function freezeInput(kind, wait){
    if(setContinuationWaiting(kind, wait)){
        publishContinuationState(true);
    }
}

async function consumeLoadedChoiceForInput(){
    while(choicesToLoad()){
        if(choicesToLoad(true)){
            let choice = pushNextChoice();
            holdForReplayedSkip(choice);
            let arg = choice.a;
            await possiblyResetChoices();
            return {
                hasChoice: true,
                arg
            };
        }
        await catchupOneStep();
    }
    return {
        hasChoice: false
    };
}

export async function pause(message, options = {cancellable: true}){
    let wait = {
        message,
        ...options,
        //choiceNum: get(_state).choices.num
    };

    if(get(res).BvB) return true;

    _state.update(s => {
        s.choices.num++;
        return s;
    })

    if(!wait.noChoiceLogging){
        let loadedChoice = await consumeLoadedChoiceForInput();
        if(loadedChoice.hasChoice) return loadedChoice.arg;
    }

    _ui.update(ui => {
        if(!ui.waiting) ui.waiting = [];

        if(wait.auto) ui.canSave = false; // TODO check this!

        ui.waiting = [wait, ...ui.waiting];
        return ui;
    })

    freezeInput('pause', wait);

    if(get(_state).burn && !options.finalMessage){
        //alert('Ending in burn: should I do anything in wait?')
        console.log('burn ending', options)
        return new Promise((resolve, reject) => {
            resolve();
        })
    }

    let p = new Promise((resolve, reject) => {
        if(get(_state).players[get(_state).activePlayer].dummy){
            // skip!
            tick().then(() => waitMillis(500).then(() => {
                if(options.cost){
                    resolve(options.cost);
                }else{
                    resolve();
                }
            }));
        }

        

        _ui.update(ui => {
            ui.waiting[0].func = resolve;
            return ui;
        })
    });
    return p;
}

export async function waitMillis(millis){
    await tick();
    await new Promise(r => setTimeout(r, millis));
}

export async function choose(message, options, extras = {}){
  // To do: add moved view?

  let movedView = false;
  if(extras.player && get(_ui).viewing != extras.player){
    movedView = get(_ui).viewing;
    changeView(extras.player);
  }

  if(get(_ui).per){
    let per = get(_ui).per;
    message = `(${per.num} of ${per.max} times) ${message}`;
  }

  let wait = {
    message,
    choices: options,
    //choiceNum: get(_state).choices.num,
    ...extras
  }

  _state.update(s => {
    s.choices.num++;
    return s;
  })

  console.log(get(_state));
  if(get(res).BvB){
    options = options.filter(o => !o.startsWith('!')); 
    if(options.length > 0) return options[0];
    return false;
  }

      
  if(!wait.noChoiceLogging){
    let loadedChoice = await consumeLoadedChoiceForInput();
    if(loadedChoice.hasChoice) return loadedChoice.arg;
  }

  // 'Don't ask again for this card' - a saved answer replays without the prompt.
  // NB it still has to log a choice: the choice log is positional, so silently
  // skipping one would desync replays and the networked opponent.
  if(wait.rememberKey && get(prefs).wildcardAuto && get(prefs).wildcardAuto.hasOwnProperty(wait.rememberKey)){
    let saved = get(prefs).wildcardAuto[wait.rememberKey];
    if(options.includes(saved)){
      if(!wait.noChoiceLogging && get(_state).activePlayer == get(_state).currentPlayer){
        pushChoice({a: saved});
      }
      return saved;
    }
  }

  if((extras.player && get(_state).players[extras.player].bot && extras.forced || get(_state).players[get(_state).activePlayer].bot) && !extras.forceChoose /*&& extras.player == get(_state).activePlayer*/){ // Last so that choices given to the non-bot will be forwarded
    options = options.filter(o => !o.startsWith('!')); // Filter out disabled ones
    if(options.length > 0) return options[0]; // !! TODO check
}



  _ui.update(ui => {
        ui.canSave = false;
        ui.selection = null;
        ui.dashboardSelected = null;
        
        if(!ui.waiting) ui.waiting = [];
        ui.waiting = [wait, ...ui.waiting];
        return ui;
  })

freezeInput('choice', wait);

if(get(_state).burn && !extras.finalMessage){
    //alert('Ending in burn: should I do anything in wait?')
    if(get(_state).burn){
        //alert('Ending in burn: should I do anything in wait?')
        return new Promise((resolve, reject) => {
            resolve();
        })
    }
}



let p = new Promise((resolve, reject) => {
    
    if(get(_state).players[get(_state).activePlayer].dummy){
        // skip!
        tick().then(() => waitMillis(500).then(() => {
            let arg = null;
            options = options.filter(o => !o.startsWith('!')); // Filter out disabled ones
            if(options.some(o => o == 'Yes')){
                arg = 'Yes';
            }else if(options.length > 0){
               arg = options[Math.floor(prng() * (options.length))];
            }
            resolve(arg);
        }));
    }

    _ui.update(ui => {
       //if(movedView) changeView(extras.player);
        ui.waiting[0].func = (arg) => {
            if(movedView) waitMillis(300).then(() => changeView(movedView));
            if(wait.card){
                console.log('waiting for card', wait);
                waitMillis(300).then(() => {
                    resolve(arg);
                });
            }else{
                console.log('not waiting for card', wait)
                resolve(arg);
            }
        }
        return ui;
    })
});
return p;

}

export function formatBytes(a,b=2){if(!+a)return"0 Bytes";const c=0>b?0:b,d=Math.floor(Math.log(a)/Math.log(1024));return`${parseFloat((a/Math.pow(1024,d)).toFixed(c))} ${["Bytes","KB","MB","GB","TB","PB","EB","ZB","YB"][d]}`}

export function getActionLog(l, showCaptain = true){
    let a = allActions.find(ac => ac.type == l.type);
    if(a && a.log){
        let log = a.log(l.params);
        if(!log) return '';
        let actor = get(_state).players[l.p];
        if(showCaptain && actor){
            log = actor.captain+' '+log;
        }else{
            log = log.slice(0, 1).toUpperCase()+log.slice(1);
        }
        if(l.g) return `!${log}`;
        return log;
    }
}

// What a log entry will actually render as, or '' if it renders nothing.
// Used to avoid drawing the separators around entries that have no text yet.
export function logEntryText(l, showCaptain = true){
    if(!l) return '';
    if(typeof l == 'string') return l;
    if(l.event == 'playerTurn' || l.event == 'phase') return l.event;
    if(l.event == 'text') return l.text || '';
    if(l.event == 'action' || l.type) return getActionLog(l, showCaptain) || '';
    return l.text || '';
}

export function hasLogText(l, showCaptain = true){
    return logEntryText(l, showCaptain).trim().length > 0;
}

export function waiting(){
    let ui = get(_ui);
    if(ui.waiting && ui.waiting.length > 0){
        if(ui.choosingCards && ui.waiting[0].cards) return 'cards';
        if(ui.waiting[0].choices) return 'choose';
        return 'pause';
    }
    return false;
}

function convertChoice(choice){
    if(choice === undefined || choice === null) return null;
    if(Array.isArray(choice)){
        let a = [];
        for(let r of choice){
            a.push(convertChoice(r));
        }
        return a;
    }else if(choice && choice.uniqueID){
        return choice.uniqueID;
    }else if(choice && choice.p && typeof choice.p == 'object'){
        let newChoice = {...choice};
        newChoice.p = getPlayerIndex(choice.p);
        return newChoice;
    }else if(choice && Object.prototype.hasOwnProperty.call(choice, 'a')){
        let newChoice = {...choice, a: convertChoice(choice.a)};
        return newChoice;
    }else{
        return choice;
    }
}

export function convertChoiceBack(choice){
    if(choice === undefined || choice === null) return null;
    if(Array.isArray(choice)){
        let a = [];
        for(let r of choice){
            a.push(convertChoiceBack(r));
        }
        return a;
    }else if(typeof choice == 'number'){
        return getCard(choice);
    }else if(choice && Object.prototype.hasOwnProperty.call(choice, 'a')){
        let newChoice = {...choice, a: convertChoiceBack(choice.a)};
        return newChoice;
    }else if(choice.p && typeof choice.p == 'number'){
        let newChoice = {...choice};
        newChoice.p = get(_state).players[choice.p];
        return newChoice;
    }else{
        return choice;
    }
}

function playerFromChoice(p){
    // Entries store `p` as a seat index, but convertChoiceBack turns any
    // non-zero index into the player object and leaves 0 as a number. Accept
    // whichever came back rather than indexing blindly.
    return typeof p == 'number' ? get(_state).players[p] : p;
}

export function backupChoice(){
    return {
        thisTurn: get(_state).choices.thisTurn,
        all: get(_state).choices.all
    };
}

export function restoreChoice(c){
    _state.update(s => {
        s.choices.thisTurn = c.thisTurn;
        s.choices.all = c.all;
        return s;
    })
}

export function pushChoice(param){
    //return; // !!! TODO reinstate once we've sorted saving etc. to avoid excessive file size
    if(get(_ui).waiting.length > 0 && get(_ui).waiting[0].turnMarker){
        param.turnMarker = true;
    }
    if(get(_ui).manualSkip) param.ms = true; // see skipForManualAction
    _state.update(s => {
        s.choices.thisTurn = [...s.choices.thisTurn, convertChoice(param)];
        s.choices.all = [...s.choices.all, convertChoice(param)];
        return s;
    })
    noteContinuationChoice();
    if(get(_state).continuation && !get(_ui).catchingUp){
        publishContinuationState(true);
    }
    // !!NB do we really need the below??
    //if(get(_ui).loadedChoices.length == 0) updateGame(get(_state), get(_state).choices.thisTurn, get(_ui), ['changelist', 'changediffs_compare']);
}

export function choicesToLoad(advance = false){
    let ret = get(_ui).loadedChoices.length > get(_state).choices.thisTurn.length;

    if(!advance) return ret;
    if(ret){
        let param = get(_ui).loadedChoices[get(_state).choices.thisTurn.length];
        if(param && Object.prototype.hasOwnProperty.call(param, 'a')) return true;
    }
}

export async function catchupFully(){
    _ui.update(ui => {
        ui.catchingUp = true;
        return ui;
    })
    await tick();
    while(choicesToLoad()){
        await catchupToChoice(); // Then choices do themselves
        console.log('waiting for new choice')
        await until(_ => !choicesToLoad() /*|| !get(_ui).loadedChoices[get(_state).choices.thisTurn.length].a*/)
        console.log('finished waiting for new choice')
    }
    _ui.update(ui => {
        ui.catchingUp = false;
        return ui;
    })
    await tick();
}

export function activePlayer(){
    return get(_state).players[get(_state).activePlayer];
}

export function currentPlayer(){
    return get(_state).players[get(_state).currentPlayer];
}

export async function catchupToChoice(){
   
    while(get(_ui).loadedChoices.length > get(_state).choices.thisTurn.length && !Object.prototype.hasOwnProperty.call(get(_ui).loadedChoices[get(_state).choices.thisTurn.length], 'a')){
        console.log('situation', get(_ui), get(_state));
        await catchupOneStep();
    }
}

export function pushNextChoice(){
    let param = get(_ui).loadedChoices[get(_state).choices.thisTurn.length];
    _state.update(s => {
        s.choices.thisTurn = [...s.choices.thisTurn, param];
        s.choices.all = [...s.choices.all, param];
        return s;
    })
    noteContinuationChoice();

    return convertChoiceBack(param);
}

export async function catchupOneStep(){
    await tick();
    await waitMillis(500);
    let loaded = get(_ui).loadedChoices;
    let current = get(_state).choices.thisTurn;
    if(choicesToLoad()){
        console.log(clone({
            loaded,
            current,
            all: get(_state).choices.all
        }));
        //alert('next choice step');
        let nextChoice = loaded[current.length];
        nextChoice = convertChoiceBack(nextChoice);
        //pushChoice(nextChoice);
        /*if(nextChoice.cn){
            await until(_ => get(_ui).waiting[0] && get(_ui).waiting[0].choiceNum == nextChoice.cn); // so that anything interim clears
        }*/
       
       if(current.length + 1 < loaded.length){
        console.log('waiting for TM?', nextChoice.turnMarker)
        if(nextChoice.turnMarker){
                await until(_ => get(_ui).waiting.length == 0 || get(_ui).waiting[0] && get(_ui).waiting[0].turnMarker)
        }else{
                await until(_ => get(_ui).waiting.length == 0 || get(_ui).waiting[0] && !get(_ui).waiting[0].turnMarker)
        }
       }else{
        console.log('last choice so not waiting');
       }
       
        // Execute it
        if(nextChoice.fca){ // fire card action
            //await until(_ => get(_ui).waiting[0] && get(_ui).waiting[0].turnMarker);
            pushChoice(nextChoice); // This one doesn't do automatically
            console.log('firing card action: resetting cache');
            _state.update(s => {
                s.cache = {
                    allPrev: [],
                };
                delete s.payingCost;
                return s;
            });
            try{
                await doAction(playerFromChoice(nextChoice.p), nextChoice.type, {card: nextChoice.fca, obj: nextChoice.fca});
            }finally{
                releaseReplayHold(); // the action a replayed skip was holding the turn for
            }
        }else if(nextChoice.act){
            // Shortcut-driven action, recorded as the action it resolved to.
            // doAction does not log a choice of its own, so push it here, the
            // same way the fca branch above does.
            pushChoice(nextChoice);
            try{
                await doAction(playerFromChoice(nextChoice.p), nextChoice.act, nextChoice.card ? {card: nextChoice.card} : {});
            }finally{
                releaseReplayHold();
            }
        }else if(nextChoice.autoActionButton){
            //await until(_ => get(_ui).waiting[0] && get(_ui).waiting[0].turnMarker);
            await autoActionButton(getCard(nextChoice.autoActionButton));
        }else if(Object.prototype.hasOwnProperty.call(nextChoice, 'a')){
            holdForReplayedSkip(nextChoice);
            _ui.update(ui => {
                ui.manualSkip = !!nextChoice.ms; // so the re-logged choice keeps its tag
                return ui;
            })
            try{
                await advance(nextChoice.a);
            }finally{
                _ui.update(ui => {
                    ui.manualSkip = false;
                    return ui;
                })
            }
        }
        await possiblyResetChoices();
    }
    //await doActionPause();
}

export async function possiblyResetChoices(){
    if(get(_ui).loadedChoices.length <= get(_state).choices.thisTurn.length){
        _ui.update(ui => {
            ui.loadedChoices = []; // Caught up, so clear
            ui.catchingUp = false;
            return ui;
        })
        await tick();
    }
    
}

export async function chooseCards(message, options, extras = {}){
    let movedView = false;
    if(extras.player && get(_ui).viewing != extras.player){
        movedView = get(_ui).viewing;
        changeView(extras.player);
    }
    let cardAreas = [];
    options = options.filter(o => o && !o.dashboardPassive); // to stop you being offered passives to choose
    for(let c of options){
        let info = get(_state).cardLog[c.uniqueID];
        if(info.area == 'players' && !cardAreas.includes(parseInt(info.player))) cardAreas.push(parseInt(info.player));
    }
    console.log(cardAreas, get(_ui).viewing);
    if(cardAreas.length == 1 && get(_ui).viewing != cardAreas[0]){
        movedView = get(_ui).viewing;
        changeView(cardAreas[0]);
    }

    if(get(_state).practice && cardAreas.length == 1 && cardAreas[0] == 1 && (get(_state).players[0].captain != 'Borg Queen' || options.some(c => get(_state).cardLog[c.uniqueID].player == 1 && get(_state).cardLog[c.uniqueID].deck != 'locations'))){
        // User is about to be asked to choose something they can't see – so just go with option 1
        if(options.length == 0) return false;
        if(extras.number){
            let num = extras.number.min || extras.number;
            return options.slice(0, num);
        }else{
            return options[0];
        }
    }

    if((get(_state).players[get(_state).activePlayer].bot)){
        let arg;
        if(extras.number){
            if(typeof extras.number == 'number'){
                arg = options.slice(0, extras.number)
            }else if(extras.number == 'all'){
                arg = options;
            }else if(extras.number == 'any'){
                // !! TODO gaining from junk!
                arg = options[0];
            }
        }else{
            arg = options[0];
        }
        return arg;
    }

    if(!extras.noChoiceLogging){
        let loadedChoice = await consumeLoadedChoiceForInput();
        if(loadedChoice.hasChoice){
            return loadedChoice.arg;
        }
    }

    if(get(_ui).per){
        let per = get(_ui).per;
        message = `(${per.num} of ${per.max} times) ${message}`;
    }
  
    let wait = {
      message,
      cards: options,
      ...extras,
      //choiceNum: get(_state).choices.num,
    }

    _state.update(s => {
        s.choices.num++;
        return s;
    })

    console.log(`choosing from`, options, extras);

    //console.log(_ui);

  
    _ui.update(ui => {
        try{
          ui.canSave = false;
          ui.selection = null;
          ui.dashboardSelected = null;

          wait.condition = (ui, state) => {
            if(extras.specialCondition) return extras.specialCondition(ui, state);
            if(ui.selection && !ui.multiSelection) return true;
            if(options.length == 0) return true;
            if(options.every(o => !o)) return true;
            if(extras.optional) return true;
            if(extras.hasOwnProperty('number')){
                if(extras.number == 'any') return true;
                if(ui.multiSelection){
                    if(typeof extras.number == 'number' && ui.multiSelection.length == extras.number) return true;
                    if(extras.number.min && ui.multiSelection.length < extras.number.min) return false;
                    if(extras.number.max && ui.multiSelection.length > extras.number.max) return false;
                    if(extras.number.exactly && ui.multiSelection.length == extras.number.num) return true;
                    if((extras.number.min || extras.number.max) && ui.multiSelection.length >= (extras.number.min || 0) && ui.multiSelection.length <= (extras.number.max || Infinity)) return true;
                }
                if(options.length < extras.number && options.every(c => ui.multiSelection.includes(c))) return true;
                //console.log(`condition not met`, extras)
                return false;
            }
            return false;
          }
          if(extras.hasOwnProperty('number')){
            ui.multiSelection = [];
          }else{
            ui.multiSelection = false;
          }
          ui.choosingCards = true;

          if(options.every(c => c && get(_state).cardLog[c.uniqueID].area == 'commons')){
            ui.choosingMarket = true;
          }else{
            ui.choosingMarket = false;
          }
  
          if(!ui.waiting) ui.waiting = [];
          ui.waiting = [wait, ...ui.waiting];
        }catch(e){
            console.log(e);
        }
        return ui;
    })

    freezeInput('cards', wait);

    //console.log(`still here`);

  let looking = false;

  

  if(extras.look && options.length > 0){
    let deck = getDeckForCard(options[0])
    looking = look(options[0], options.map(c => deck.findIndex(cd => cd == c)), false, extras.reorder);
  }

  if(extras.lookSpecific && options.length > 0){
    looking = lookAtCards(options);
  }

  //console.log(get(_state).cache);

  if(get(_state).cache && get(_state).cache.showCards && options.some(o => get(_state).cache.showCards.some(c => c == o.uniqueID))){
    closeAllLooks();
    //closeAllLooks(true); // To avoid duplicate looks TODO could be selective?
    looking = lookAtCards(get(_state).cache.showCards.map(c => getCard(c)));
  }
  //console.log(`still here 2`);

  if(extras.number){
    if(typeof extras.number == 'number' && options.length == extras.number){
        _ui.update(ui => {
            ui.selection = options[0];
            ui.multiSelection = options;
            return ui;
        })
    }
  }else if(options.length == 1 && !extras.optional){
    _ui.update(ui => {
        ui.selection = options[0];
        return ui;
    })
  }

  //console.log(`still here 3`);
  
  let p = new Promise((resolve, reject) => {
    //console.log(`still here 3.5`);
    console.log(get(_state).players[get(_state).activePlayer]);
        
        if(get(_state).players[get(_state).activePlayer].dummy){
            // skip!
            tick().then(() => waitMillis(500).then(() => {
                let arg = null;
                if(!extras.number){
                    if(options.length > 0){
                        arg = options[Math.floor(prng() * (options.length))];
                     }
                }else{
                    let num = extras.number;
                    if(num.min) num = num.min;
                    if(num.max) num = num.max;
                    if(num == 'all' || num == 'any'){
                        arg = options;
                    }else{
                        let chosen = [];
                        let subset = options;
                        while(chosen.length < extras.number && subset.length > 0){
                            subset = options.filter(c => !chosen.includes(c));
                            chosen.push(subset[Math.floor(prng() * subset.length)]);
                        }
                        arg = chosen;
                    }
                }
                resolve(arg);
            }));
        }

      _ui.update(ui => {
        ui.waiting[0].func = (arg) => {
            if(movedView) waitMillis(300).then(() => changeView(movedView)); 
            if(looking) closeLook(looking);
            ui.choosingMarket = false;
            //if(arg == 'cancelled') throw 'cancelled'; // ?? 
            resolve(arg);
        }
        return ui;
      })
      //console.log(`still here 4`);
  });
  return p;
  
  }

export async function advance(param = undefined){
    let hasParam = arguments.length > 0;
    console.log('advancing wait', get(_ui))
    if(get(_ui).waiting.length == 0 || !get(_ui).waiting[0]) return;
    let func = get(_ui).waiting[0].func; 
    if(!func) return;
    let catchupAfter = false;

    if(get(_state).botWorking && !get(_ui).waiting.some(w => w.hasOwnProperty('choices') || w.hasOwnProperty('cards') || w.hasOwnProperty('cost'))) return; // Don't advance whilst bot is busy

    // !! TODO the below to 
    /*if(get(_ui).waiting[0].cardElement){
        get(_ui).waiting[0].cardElement.$destroy();
    }*/

   if(!get(_ui).waiting[0].noChoiceLogging && get(_state).activePlayer == get(_state).currentPlayer){
        // This feels like a very ugly solution...
        // ...the rationale is that the currentPlayer dictates the flow of the turn here,
        // so a choice being taken by the other player should not be logged.
        // Which is fine as long as the effect passing _is_ logged somehow...
        pushChoice({
            a: hasParam ? param : null
        });
    }else if(get(_ui).waiting[0].noChoiceLogging){
        catchupAfter = true;
    }

    _ui.update(ui => {
        ui.waiting = ui.waiting.slice(1);
        return ui;
    })

    if(hasParam){
        func(param);
    }else{
        func();
    }

    live.update(l => {
        l.infoToDisplay = false;
        return l;
    })

    


    _ui.update(ui => {
        if(!get(prefs).turnSaves && !ui.waiting.some(w => w.hasOwnProperty('choices') || w.hasOwnProperty('auto'))){
            ui.canSave = true;
        }
    
        if(ui.choosingCards){
            ui.choosingCards = false;
            // TODO fixif(param && param.uniqueID) doToCard(context, param, 'hideLook');
        }
    
        if(ui.multiSelection){
            ui.multiSelection = false;
        }
        
        return ui;
    })

    if(catchupAfter && choicesToLoad()){ // So that we're bac 
        await catchupOneStep(); 
    }
    if(get(_ui).waitingComponent.length > 0){
        try{
            for(let c of get(_ui).waitingComponent){
                if(!c) continue;
                c.$destroy();
            }
        }catch(e){
            console.log('Unable to destroy waiting component', e, get(_ui).waitingComponent);
        }
        _ui.update(ui => {
            ui.waitingComponent = [];
            return ui;
        })
    }
}

export function cancel(card, reason){
    console.log('Cancelling: '+reason)
    if(typeof card == 'number') card = getCard(card);
    cardMessage(card, reason);
    changePlayer(get(_state).currentPlayer); // Revert back to the main person – hopefully ok
    // Put reason on message
    throw 'cancelled';
}

export function cn(n){
    if(!n) return 1;
    if(typeof n === 'number') return `${n}`;
    if(n.text) return n.text;
    if(n.exactly) return `exactly ${n.num}`;
    if(Array.isArray(n)) return n.join('/');
    return n;
}

export function cc(c, prefix = ''){
    if(!c) return '';
    if(typeof c === 'number'){
        let co = getPlayerIndex(cardOwner(getCard(c)));
        return `$|${prefix}${co},${c}|$`;
    }
    if(Array.isArray(c)){
        return `$|${c.map(c => {
            let co = getPlayerIndex(cardOwner(getCard(c)));
            return `${prefix}${co},${c}`
        }).join('|$$|')}|$`;
    }
    if(c && typeof c === 'object'){
        let co = getPlayerIndex(cardOwner(c));
        return `$|${prefix}${co},${c.uniqueID}|$`;
    }
    return '';
}

export function isTouchDevice(override = true) {
    if(get(prefs).forceNotTouch && override) return false;
    return (('ontouchstart' in window) ||
        (navigator.maxTouchPoints > 0) ||
        (navigator.msMaxTouchPoints > 0));
}

export function announce(message){
    if(get(res).BvB) return true;
    _ui.update(ui => {
        /*if(!ui.announcement){
            ui.announcement = message;
        }else{
            ui.announcement = ui.announcement + '\n' + message;
        }*/
        ui.announcement = message;
        
        return ui;
    })
    waitMillis(get(prefs).announcementPause).then(() => {
        _ui.update(ui => {
            ui.announcement = false;
            return ui;
        })
    })
}

export function flashIndicator(name){
    if(get(res).BvB) return true;
    _ui.update(ui => {
        /*if(!ui.announcement){
            ui.announcement = message;
        }else{
            ui.announcement = ui.announcement + '\n' + message;
        }*/
        ui.indicators[name] = true;
        
        return ui;
    })
    waitMillis(250).then(() => {
        _ui.update(ui => {
            ui.indicators[name] = false;
            return ui;
        })
    })
}

export function debounce(mainFunction, delay){
    // Declare a variable called 'timer' to store the timer ID
    let timer;
  
    // Return an anonymous function that takes in any number of arguments
    return function (...args) {
      // Clear the previous timer to prevent the execution of 'mainFunction'
      clearTimeout(timer);
  
      // Set a new timer that will execute 'mainFunction' after the specified delay
      timer = setTimeout(() => {
        //console.log('executing function')
        mainFunction(...args);
      }, delay);
    };
  };
